// Category-matched photography used when the original hrdmimarlik.com asset
// cannot be reached from the visitor's network (approved substitution).
export const CAT_IMAGES = {
  Residential: [
    "https://images.unsplash.com/photo-1605774337664-7a846e9cdf17",
    "https://images.unsplash.com/photo-1667312939978-64cf31718a6e",
    "https://images.unsplash.com/photo-1598928506311-c55ded91a20c",
    "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92",
    "https://images.unsplash.com/photo-1495321308589-43affb814eee",
    "https://images.pexels.com/photos/3062948/pexels-photo-3062948.jpeg",
    "https://images.unsplash.com/photo-1584247793672-567c535a5e44",
  ],
  Retail: [
    "https://images.unsplash.com/photo-1588398876755-3f75facef354?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxib3V0aXF1ZSUyMGludGVyaW9yfGVufDB8fHx3aGl0ZXwxNzg1MTc2OTY4fDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1595991209106-aab2f13cd85b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxtaW5pbWFsJTIwc3RvcmV8ZW58MHx8fHdoaXRlfDE3ODUxNzY5Nzl8MA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1561490497-43bc900ac2d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxzaG93cm9vbXxlbnwwfHx8d2hpdGV8MTc4NTE3Njk3OXww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1581572473321-c0a80a8fd199?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxtaW5pbWFsJTIwc3RvcmV8ZW58MHx8fHdoaXRlfDE3ODUxNzY5Nzl8MA&ixlib=rb-4.1.0&q=85",
    "https://images.pexels.com/photos/27452443/pexels-photo-27452443.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ],
  Hospitality: [
    "https://images.unsplash.com/photo-1655988940601-7702d8685f95?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxicmlnaHQlMjBpbnRlcmlvcnxlbnwwfHx8d2hpdGV8MTc4NTE3NzAwN3ww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1556595101-15dc5f6431e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxicmlnaHQlMjBpbnRlcmlvcnxlbnwwfHx8d2hpdGV8MTc4NTE3NzAwN3ww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1621293954908-907159247fc8",
  ],
  Wellness: [
    "https://images.unsplash.com/photo-1611920630418-f587fdc3bf94",
    "https://images.pexels.com/photos/32203052/pexels-photo-32203052.jpeg",
    "https://images.unsplash.com/photo-1693578538512-fc66f318c833",
  ],
  Healthcare: [
    "https://images.unsplash.com/photo-1570105954248-fa0c1376edfe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxhaXJ5JTIwY2xpbmljJTIwd2FpdGluZ3xlbnwwfHx8d2hpdGV8MTc4NTE3Njk1N3ww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1565742319477-fd961565e476?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHx3YWl0aW5nJTIwcm9vbXxlbnwwfHx8d2hpdGV8MTc4NTE3NzAwMHww&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1693578538512-fc66f318c833",
    "https://images.unsplash.com/photo-1611920630418-f587fdc3bf94",
    "https://images.unsplash.com/photo-1605774337664-7a846e9cdf17",
  ],
  Office: [
    "https://images.unsplash.com/photo-1497366811353-6870744d04b2",
    "https://images.unsplash.com/photo-1497366754035-f200968a6e72",
    "https://images.unsplash.com/photo-1667312939978-64cf31718a6e",
    "https://images.unsplash.com/photo-1675528030748-d463ab87e8d5",
    "https://images.unsplash.com/photo-1701422052139-e72ee5e67249",
    "https://images.unsplash.com/photo-1543646269-fcc4ba67ac5f",
    "https://images.unsplash.com/photo-1698047736474-3c1e5a0d3526",
  ],
  "F&B": [
    "https://images.unsplash.com/photo-1586864030275-edd6e51dc880?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxjb2ZmZWUlMjBzaG9wfGVufDB8fHx3aGl0ZXwxNzg1MTc3MDAwfDA&ixlib=rb-4.1.0&q=85",
    "https://images.unsplash.com/photo-1539292069291-55b91c38f3f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHxtaW5pbWFsJTIwcmVzdGF1cmFudHxlbnwwfHx8d2hpdGV8MTc4NTE3NzAwN3ww&ixlib=rb-4.1.0&q=85",
  ],
};

export const DETAIL_IMAGES = [
  "https://images.unsplash.com/photo-1679996644490-14c2e6726d0f",
  "https://images.unsplash.com/photo-1566750838513-08a952c392c8",
  "https://images.unsplash.com/photo-1463995439889-6cc080aaf7dd",
  "https://images.unsplash.com/photo-1675528030748-d463ab87e8d5",
  "https://images.unsplash.com/photo-1543646269-fcc4ba67ac5f",
  "https://images.unsplash.com/photo-1701422052139-e72ee5e67249",
  "https://images.unsplash.com/photo-1697507695420-04623ccff2af",
  "https://images.unsplash.com/photo-1571205086863-9d186c5cb8fb",
  "https://images.unsplash.com/photo-1584247793672-567c535a5e44",
  "https://images.unsplash.com/photo-1495321308589-43affb814eee",
  "https://images.unsplash.com/photo-1781032040825-04240013c228",
  "https://images.unsplash.com/photo-1685022515887-c2a10c137162",
];

export function attachFallbacks(projects, defaults) {
  const counters = {};
  projects.forEach((p) => {
    const arr = CAT_IMAGES[p.category] || defaults;
    counters[p.category] =
      counters[p.category] === undefined ? 0 : counters[p.category] + 1;
    p.fallback = arr[counters[p.category] % arr.length];
  });
  return projects;
}
